import z from 'zod';

export const contactMessageWriteSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  email: z.email('Invalid email address'),
  message: z.string().min(1, 'Message is required'),
  uid: z.string().nullish().optional(),
});

export type ContactMessageWrite = z.infer<typeof contactMessageWriteSchema>;
